import React, { Fragment } from 'react';
import withStyles from '@mui/styles/withStyles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '../form/Button';

export default withStyles({})(({ open, onCancel, onAccept, title, message }) => {
    const handleClose = (event, reason) => {
        const { onCancel } = this.props;
        if (reason && reason === 'backdropClick') {
            return; // Do nothing if the backdrop is clicked
        }
        onCancel && onCancel(event);
    };
    return (
        <Dialog
            disableEscapeKeyDown
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                {onAccept ? (
                    <Fragment>
                        <Button onClick={onCancel} variant="modal-action modal-action--cancel">
                            Cancel
                        </Button>
                        <Button onClick={onAccept} variant="modal-action modal-action--ok" autoFocus>
                            Ok
                        </Button>
                    </Fragment>
                ) : (
                    <Fragment>
                        <Button onClick={onCancel} variant="modal-action modal-action--cancel" autoFocus>
                            Close
                        </Button>
                    </Fragment>
                )}
            </DialogActions>
        </Dialog>
    );
});
